import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ModalService } from 'service/modal.service';
import { PeerCursor } from '@udonarium/peer-cursor';

interface Player {
    name: string;
    available: { [key: string]: boolean | null };
}

interface Ougi {
    id: number;
    name: string;
    text: string;
}

@Component({
    selector: 'technique-selection',
    templateUrl: './technique-selection.component.html',
    styleUrls: ['./technique-selection.component.css']
})
export class TechniqueSelectionComponent implements OnInit {
    player: Player = null;
    techniques: string[] = [];
    selectedTechniques: string[] = [];
    techniqueMetadata: { [key: string]: string } = {};
    ougis: Ougi[] = [];
    hoveredTech: string | null = null;

    constructor(
        private http: HttpClient,
        private modalService: ModalService
    ) { }

    ngOnInit(): void {
        if (this.modalService.option) {
            this.player = this.modalService.option.player;
            this.ougis = this.modalService.option.ougis || [];
            this.modalService.title = `Choose Your Technique - ${this.player.name}`;
            this.techniques = Object.keys(this.player.available);
            this.loadMetadata();
        }
    }

    loadMetadata() {
        this.http.get<any>('./assets/data/kisekigoma.json').subscribe(data => {
            const allItems = data.ougi.concat(data.kotodama, data.otonashi);
            allItems.forEach(item => {
                this.techniqueMetadata[item.filename] = item.text;
            });
        }, error => {
            // Check fallback path if assets/data/ matches kisekigoma.json location
            console.warn('Trying secondary path for kisekigoma.json');
            this.http.get<any>('./app/json/kisekigoma.json').subscribe(data => {
                const allItems = data.ougi.concat(data.kotodama, data.otonashi);
                allItems.forEach(item => {
                    this.techniqueMetadata[item.filename] = item.text;
                });
            });
        });
    }

    get hoveredEffect(): string {
        if (!this.hoveredTech) return '駒にカーソルを合わせると効果が表示されます';

        // まず Ougis データから探す
        const ougi = this.ougis.find(o => o.name === this.hoveredTech);
        if (ougi) return ougi.text;

        // なければ kisekigoma metadata から探す
        return this.techniqueMetadata[this.hoveredTech] || '効果情報なし';
    }

    onHover(tech: string) {
        this.hoveredTech = tech;
    }

    onLeave() {
        this.hoveredTech = null;
    }

    toggleSelection(tech: string) {
        if (this.player.available[tech] === null) return; // Locked

        const index = this.selectedTechniques.indexOf(tech);
        if (index > -1) {
            this.selectedTechniques.splice(index, 1);
        } else {
            if (this.selectedTechniques.length < 3) {
                this.selectedTechniques.push(tech);
            }
        }
    }

    isSelected(tech: string): boolean {
        return this.selectedTechniques.includes(tech);
    }

    isLocked(tech: string): boolean {
        return this.player.available[tech] === null;
    }

    confirm() {
        if (this.selectedTechniques.length > 0) {
            // this.sendLogToServer();
        }
        this.modalService.resolve(this.selectedTechniques);
    }

    private sendLogToServer() {
        const playerName = this.player ? this.player.name : (PeerCursor.myCursor ? PeerCursor.myCursor.name : 'Unknown');
        const now = new Date();
        const timestamp = `[${now.getFullYear()}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getDate().toString().padStart(2, '0')} ${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}]`;
        const techStr = this.selectedTechniques.join('・');
        const logEntry = `${timestamp} ${playerName} は、${techStr} を選択した。\n`;

        const logUrl = 'https://mitarashi.link/events_api/log/spring2026.log';
        const apiURL = 'https://mitarashi.link/events_api/events-api.php?file=log/spring2026.log';

        // 現状のログファイルを読み込んで追記し、サーバーへ上書き保存（既存の大会データ更新パターン）
        this.http.get(logUrl, { responseType: 'text' }).subscribe(
            existingLog => {
                const updatedLog = (existingLog || '') + logEntry;
                this.http.post(apiURL, updatedLog, { responseType: 'text' }).subscribe(
                    res => console.log('Selection log appended successfully'),
                    err => console.error('Failed to append selection log', err)
                );
            },
            err => {
                // ファイルが存在しないか取得できない場合は新規作成
                this.http.post(apiURL, logEntry, { responseType: 'text' }).subscribe(
                    res => console.log('Selection log created successfully'),
                    err => console.error('Failed to create selection log', err)
                );
            }
        );
    }

    close() {
        this.modalService.resolve(null);
    }
}
